import { render, staticRenderFns } from "./wxSettingsIndex.vue?vue&type=template&id=8c070338&scoped=true"
import script from "./wxSettingsIndex.vue?vue&type=script&lang=js"
export * from "./wxSettingsIndex.vue?vue&type=script&lang=js"
import style0 from "./wxSettingsIndex.vue?vue&type=style&index=0&id=8c070338&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c070338",
  null
  
)

export default component.exports